module.exports = __webpack_public_path__ + "media/standardized_tests/FinAid_callout-b6bfac3a.jpg";